import { PageRouteProps } from "../../types";

export const microServiceRoutes: PageRouteProps[] = [
  {
    pathName: "/admin/microservice/list",
    module: ["Ecommerce"],
    component: "MicroServiceList",
    type: "admin",
    mode: "static",
  },
  {
    pathName: "/admin/microservice/add",
    module: ["Ecommerce"],
    component: "AddMicroService",
    type: "admin",
    mode: "static",
  },
  {
    pathName: "/admin/microservice/category",
    module: ["Ecommerce"],
    component: "MicroServiceCategory",
    type: "admin",
    mode: "static",
  },
  {
    pathName: "/admin/microservice/edit",
    module: ["Ecommerce"],
    component: "AddMicroService",
    type: "admin",
    mode: "dynamic",
  },
  {
    pathName: "/admin/trash/microservice/list",
    module: ["Ecommerce"],
    component: "MicroServiceList",
    type: "admin",
    mode: "static",
  },
];
